import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "constants/defaultValues";
import { clientApplication } from "./client";
import { toast } from "react-toastify";

export const getAsyncVenueInfo = createAsyncThunk(
  "profile/getAsyncVenueInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const respons = await clientApplication.get(
        `${baseUrlApi}/profile/${payload.id}`
      );
      return respons.data;
    } catch (error) {
      return rejectWithValue([], error);
      toast.error("server side error!");
    }
  }
);
export const getAsyncMenu = createAsyncThunk(
  "product/getAsyncMenu",
  async (payload, { rejectWithValue }) => {
    try {
      const respons = await clientApplication.get(
        `${baseUrlApi}/product/venue/${payload.id}/categorized`
      );
      return respons.data;
    } catch (error) {
      return rejectWithValue([], error);
      toast.error("server side error!");
    }
  }
);
export const getOrderData = createAsyncThunk(
  "product/getOrderData",
  async (payload, { rejectWithValue }) => {
    try {
      const respons = await clientApplication.get(
        `${baseUrlApi}/order/guest/${payload?.venueID}/${payload?.tableNumber}`
      );
      return respons.data;
    } catch (error) {
      return rejectWithValue([], error);
      toast.error("server side error!");
    }
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState: {
    //getAsyncVenueInfo:
    venueInfo: {},
    venueInfoLoading: false,
    venueInfoError: null,
    //getAsyncMenu:
    menuData: {},
    menuDataLoading: false,
    menuDataError: null,
    //
    orderData: {},
    orderDataLoading: false,
    orderDataError: null,
  },
  extraReducers: {
    // getAsyncVenueInfo
    [getAsyncVenueInfo.pending]: (state, action) => {
      return {
        ...state,
        venueInfo: {},
        venueInfoLoading: true,
        venueInfoError: null,
      };
    },
    [getAsyncVenueInfo.fulfilled]: (state, action) => {
      return {
        ...state,
        venueInfo: action.payload,
        venueInfoLoading: false,
        venueInfoError: null,
      };
    },
    [getAsyncVenueInfo.rejected]: (state, action) => {
      return {
        ...state,
        venueInfo: action.payload,
        venueInfoLoading: false,
        venueInfoError: action.error.message,
      };
    },
    // getAsyncMenu
    [getAsyncMenu.pending]: (state, action) => {
      return {
        ...state,
        menuData: {},
        menuDataLoading: true,
        menuDataError: null,
      };
    },
    [getAsyncMenu.fulfilled]: (state, action) => {
      return {
        ...state,
        menuData: action.payload?.data?.map((el, index) => {
          return {
            ...el,
            fakeId: index + 10,
          };
        }),
        menuDataLoading: false,
        menuDataError: null,
      };
    },
    [getAsyncMenu.rejected]: (state, action) => {
      return {
        ...state,
        menuData: action.payload,
        menuDataLoading: false,
        menuDataError: action.error.message,
      };
    },
    //getOrderData
    [getOrderData.pending]: (state, action) => {
      return {
        ...state,
        orderData: {},
        orderDataLoading: true,
        orderDataError: null,
      };
    },
    [getOrderData.fulfilled]: (state, action) => {
      return {
        ...state,
        orderData: action.payload,
        orderDataLoading: false,
        orderDataError: null,
      };
    },
    [getOrderData.rejected]: (state, action) => {
      return {
        ...state,
        orderData: action.payload,
        orderDataLoading: false,
        orderDataError: action.error.message,
      };
    },
  },
});

export default profileSlice.reducer;
